import { useCallback } from 'react'
import { usePylon } from '@renderer/providers/PylonProvider'
import { AmplitudeRenderer } from '@renderer/utils/amplitude.renderer'

/**
 * Opens the support chat. Every "contact support" affordance goes through here
 * so they land in the same Pylon thread the help menu opens, rather than
 * bouncing out to the help centre in a browser where support can't answer.
 *
 * Only callable from a window that mounts `PylonProvider`: overlay, chat, settings.
 */
export function useContactSupport(source: string) {
  const pylon = usePylon()

  return useCallback(() => {
    AmplitudeRenderer.trackEvent('Get Help', { action: 'Contact Support', source })
    pylon.show()
  }, [pylon, source])
}
